import { render } from "./DayPlannerHeader.vue?vue&type=template&id=4d0176be&scoped=true"
import script from "./DayPlannerHeader.vue?vue&type=script&lang=js"
export * from "./DayPlannerHeader.vue?vue&type=script&lang=js"

import "./DayPlannerHeader.vue?vue&type=style&index=0&id=4d0176be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0176be"]])

export default __exports__